import { css } from "@emotion/react";

import { COLORS } from "../stylesheets/emotion/vars";

export const mississippiLegend = css`
    .legend {
        position: absolute;
        bottom: -5.2vw;
        right: -3.5vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 1.9vw;
                }
                .legendRow {
                    margin-top: -0vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 2vw;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.7vw;
                        font-size: 1.2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;

export const missouriLegend = mississippiLegend;

export const mississippiVerticalLegend = css`
    .legend {
        position: absolute;
        bottom: -122.5vw;
        right: -4vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 1.9vw;
                }
                .legendRow {
                    margin-top: -0vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 1.75vw;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.5vw;
                        font-size: 1.2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;

export const missouriVerticalLegend = mississippiVerticalLegend;

export const maryJaneLegend = css`
    .legend {
        position: absolute;
        bottom: 0vw;
        right: 0vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 1.3vw;
                }
                .legendRow {
                    margin-top: 0vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 3vw;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.5vw;
                        font-size: 1.2vw;
                        font-family: "anton-black", "sans-serif";
                        color: ${COLORS.maryJaneColor};
                    }
                }
            }
            .content::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: ${COLORS.maryJaneRowColor};
                opacity: 0.72;
                z-index: -1;
            }
        }
    }
`;

export const maryJaneVerticalLegend = css`
    .legend {
        position: absolute;
        bottom: 0vw;
        right: 0vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 2vw;
                }
                .legendRow {
                    align-items: center;
                    margin-top: 0vw;
                    display: flex;
                    flex-direction: row;
                    padding-right: 3vw;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.5vw;
                        font-size: 1.2vw;
                        font-family: "anton-black", "sans-serif";
                        color: ${COLORS.maryJaneColor};
                    }
                }
            }
            .content::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: ${COLORS.maryJaneRowColor};
                opacity: 0.72;
                z-index: -1;
            }
        }
    }
`;

export const easyGoingLegend = css`
    .legend {
        position: absolute;
        bottom: -5vw;
        right: -1vw;
        width: 45vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.easyGoingColor};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 1.4vw;
                }
                .legendRow {
                    margin-top: 0vw;
                    display: flex;
                    flex-direction: row;
                    padding-right: 2vw;
                    align-items: center;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.5vw;
                        font-size: 1.2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;

export const easyGoingVerticalLegend = css`
    .legend {
        position: absolute;
        bottom: 5.5vw;
        right: -2vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.easyGoingColor};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 2vw;
                }
                .legendRow {
                    margin-top: 0vw;
                    display: flex;
                    flex-direction: row;
                    padding-right: 1.75vw;
                    align-items: center;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        margin-left: 0.5vw;
                        font-size: 1.4vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;

export const deSteegLegend = css`
    .legend {
        position: absolute;
        bottom: 0vw;
        right: 0vw;
        width: 46vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                box-shadow: inset 0 0 128px rgba(0, 0, 0, 0.6);
                border-radius: 0.5vw;
                justify-content: center;
                align-items: center;
                padding: 0.3vw;
                gap: 3vw;
                .legendRow {
                    display: flex;
                    align-items: center;
                    gap: 0.4vw;
                    .newIcon {
                        position: relative;
                        margin-bottom: 0.3vw;
                    }
                    .label {
                        font-size: 1.2vw;
                        color: white;
                    }
                }
            }
        }
    }
`;

export const roundAboutLegend = css`
    .legend {
        position: absolute;
        bottom: 0vw;
        right: 0vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                box-shadow: inset 0 0 128px rgba(0, 0, 0, 0.6);
                border-radius: 15px;
                justify-content: center;
                align-items: center;
                padding: 0.4vw;
                gap: 3vw;
                .legendRow {
                    display: flex;
                    align-items: center;
                    gap: 0.4vw;
                    .newIcon {
                        position: relative;
                        margin-bottom: 1vw;
                    }
                    .label {
                        font-size: 1.2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;

export const roundAboutLegendVertical = css`
    .legend {
        position: absolute;
        bottom: 0vw;
        right: 0vw;
        width: 49vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                padding: 0.75vw;
                .legendBadge {
                    height: 1.9vw;
                }
                .legendRow {
                    margin-top: -0vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 2vw;
                    .newIcon {
                        position: relative;
                    }
                    .label {
                        padding-left: 0.7vw;
                        font-size: 1.5vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
    }
`;
